import React, { useContext, useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import InputField from "../../Components/InputField";
import { postData } from "../../Utils/AxiosRequest";
import {
  API_PATHS,
  errorMessages,
  URL_PATH,
} from "../../Utils/Constants/constants";
import { Spinner } from "react-bootstrap";
import CenterModal from "../../Components/CenterModal";
import { LoginContext } from "../../Contexts/LoginContext";
// import ReCAPTCHA from "react-google-recaptcha";
import { encryptPassword } from "../../Utils/Auth/encription";
import { passwordValidator } from "../../Utils/validation/validators";
import { generateMathCaptcha } from "../../Utils/Auth/captchaAuth";
import Captcha from "./Captcha";

const ForgotPassword = () => {
  // const captchaSiteKey = process.env.REACT_APP_CAPTCHA_SITEKEY;
  const [otpSent, setOtpSent] = useState(false);
  const [enterPass, setEnterPass] = useState(false);
  const [passwordError, setPasswordError] = useState(null);
  const [isPassDirty, setIsDirty] = useState(false);

  const { isLoggedIn, setIsLoggedIn } = useContext(LoginContext);
  const [data, setData] = useState({
    Email: "",
    Mobile: "",
    Password: "",
    ConfirmPassword: "",
    rememberMe: false,
    Otp: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(generateMathCaptcha());
  const [userCaptcha, setUserCaptcha] = useState("");
  const [message, setMessage] = useState({
    heading: "",
    description: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const mobileRegex = /^\d{1,10}$/;
    const name = e.target.name;
    let value = e.target.value;

    if (name === "Mobile" && value.length !== 0 && !mobileRegex.test(value)) {
      return;
    }

    if (name === "Password" && isPassDirty) {
      const isPassValid = passwordValidator(value);
      if (isPassValid !== true) {
        setPasswordError(isPassValid);
      } else {
        setPasswordError(null);
      }
    }

    if (
      name === "ConfirmPassword" &&
      passwordError === "Password and confirm password does not match."
    ) {
      if (data.ConfirmPassword === value) {
        setPasswordError(null);
      }
    }

    if (name === "Otp") {
      if (value.length > 6) {
        value = value.slice(0, 6);
      }
      value = value.trim().toUpperCase();
    }

    setData((prvs) => {
      const newData = { ...prvs, [name]: value };
      return newData;
    });
  };

  const handleCaptchaChange = () => {
    setCaptchaToken(generateMathCaptcha());
    setUserCaptcha("");
  };

  const handleGetOtp = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (!data.Email || !data.Mobile) {
      return;
    }
    if (parseInt(userCaptcha) !== captchaToken.answer) {
      setShowModal(true);
      setMessage({
        heading: "Invalid Captcha",
        description: "Please complete CAPTCHA verification",
      });
      setIsSubmitting(false);
      return;
    }
    const reqBody = {
      Username: data.Email.trim(),
      Mobile: data.Mobile,
    };

    try {
      const response = await postData(API_PATHS.forgotPasword, reqBody);

      if (response.status === 200) {
        if (response.data.IsSuccess) {
          setOtpSent(true);
        }
      } else {
        handleCaptchaChange();
        setOtpSent(false);
        setShowModal(true);
        setMessage({
          heading: errorMessages.error,
          description: errorMessages.description,
        });
      }
    } catch (error) {
      handleCaptchaChange();
      console.error(error);
      setOtpSent(false);
      setShowModal(false);
      setMessage({
        heading: errorMessages.error,
        description: errorMessages.description,
      });
    }
    setIsSubmitting(false);
  };
  const handleSubmitOtp = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (!data.Otp) {
      return;
    }
    const reqBody = {
      Email: data.Email.trim(),
      MobileOtp: data.Otp,
      EmailOTP: data.Otp,
    };

    try {
      const response = await postData(API_PATHS.verifyForgotOtp, reqBody);

      if (response.status === 200) {
        if (response.data.IsSuccess) {
          setEnterPass(true);
        } else {
          switch (message) {
            case "OTP mismatch!!!":
              setShowModal(true);
              setMessage({
                heading: "Invalid OTP",
                description: "OTP is invalid.",
              });
              break;
            case "OTP expired!!!":
              setShowModal(true);
              setMessage({
                heading: "Invalid OTP",
                description: "OTP Expired.",
              });
              break;
            default:
              setShowModal(true);
              setMessage({
                heading: errorMessages.error,
                description: errorMessages.errorDescription,
              });
          }
        }
      } else {
        setOtpSent(false);
        setShowModal(true);
        setMessage({
          heading: errorMessages.error,
          description: errorMessages.description,
        });
      }
    } catch (error) {
      console.error(error);
      setOtpSent(false);
      setShowModal(false);
      setMessage({
        heading: errorMessages.error,
        description: errorMessages.description,
      });
    } finally {
      setData((prvs) => ({
        ...prvs,
        Otp: "",
      }));
    }
    setIsSubmitting(false);
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setIsDirty(true);
    if (!data.Password) {
      return;
    }
    if (data.Password.length < 8) {
      setPasswordError("Password should be atleast 8 characters.");
      return;
    }
    if (data.Password.length > 32) {
      setPasswordError("Password can not be greater than 32 characters.");
      return;
    }
    if (data.Password !== data.ConfirmPassword) {
      setPasswordError("Password and confirm password does not match.");
      return;
    }
    setIsSubmitting(true);
    const reqBody = {
      Email: data.Email.trim(),
      NewPassword: encryptPassword(data.Password),
    };

    try {
      const response = await postData(API_PATHS.updatePassword, reqBody);

      if (response.status === 200) {
        if (response.data.IsSuccess) {
          navigate(URL_PATH.login);
        } else {
          switch (message) {
            case "OTP mismatch!!!":
              setShowModal(true);
              setMessage({
                heading: "Invalid OTP",
                description: "OTP is invalid.",
              });
              break;
            case "OTP expired!!!":
              setShowModal(true);
              setMessage({
                heading: "Invalid OTP",
                description: "OTP Expired.",
              });
              break;
            default:
              setShowModal(true);
              setMessage({
                heading: errorMessages.error,
                description: errorMessages.errorDescription,
              });
          }
        }
      } else {
        setOtpSent(false);
        setShowModal(true);
        setMessage({
          heading: errorMessages.error,
          description: errorMessages.description,
        });
      }
    } catch (error) {
      console.error(error);
      setOtpSent(false);
      setShowModal(false);
      setMessage({
        heading: errorMessages.error,
        description: errorMessages.description,
      });
    }
    setIsSubmitting(false);
  };

  if (isLoggedIn) {
    return <Navigate to={URL_PATH.memberhome} />;
  }

  return (
    <section className="main-login">
      <div className="main-login-bg">
        <div className="container">
          <div className="login-container">
            <h3 className="main-title mb-3">Forgot Password</h3>
            <div className="common-form">
              {otpSent && enterPass ? (
                <form onSubmit={handleUpdatePassword}>
                  <div className="form-group">
                    <InputField
                      type="password"
                      placeholder="Password"
                      name="Password"
                      value={data.Password}
                      onChange={handleChange}
                      autoComplete="off"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <InputField
                      type="password"
                      placeholder="Confirm Password"
                      name="ConfirmPassword"
                      value={data.ConfirmPassword}
                      onChange={handleChange}
                      autoComplete="off"
                      required
                    />
                  </div>
                  {passwordError && (
                    <div className="pb-2">
                      <p className="text-danger text-left p-0 m-0">{`* ${passwordError}`}</p>
                    </div>
                  )}
                  <div className="form-group">
                    {isSubmitting ? (
                      <button
                        className="btn green-btn  w-100 cursor-na"
                        disabled
                      >
                        <Spinner size="sm" />
                      </button>
                    ) : (
                      <input
                        type="submit"
                        className="btn green-btn  w-100"
                        value="Submit"
                      />
                    )}
                  </div>
                </form>
              ) : otpSent ? (
                <form onSubmit={handleSubmitOtp}>
                  <div className="form-group">
                    <InputField
                      type="text"
                      placeholder="Otp"
                      name="Otp"
                      value={data.Otp}
                      onChange={handleChange}
                      autoComplete="off"
                      required
                    />
                  </div>
                  <div className="form-group">
                    {isSubmitting ? (
                      <button
                        className="btn green-btn  w-100 cursor-na"
                        disabled
                      >
                        <Spinner size="sm" />
                      </button>
                    ) : (
                      <input
                        type="submit"
                        className="btn green-btn  w-100"
                        value="Submit"
                      />
                    )}
                  </div>
                </form>
              ) : (
                <form onSubmit={handleGetOtp}>
                  <div className="form-group">
                    <InputField
                      type="email"
                      placeholder="Email"
                      name="Email"
                      value={data.Email}
                      onChange={handleChange}
                      autoComplete="off"
                      required
                    />
                    <div className="form-group mt-2">
                      <InputField
                        type="text"
                        placeholder="Mobile Number"
                        name="Mobile"
                        value={data.Mobile}
                        onChange={handleChange}
                        autoComplete="off"
                        required
                      />
                    </div>
                  </div>
                  {data.Email && data.Mobile ? (
                    <div className="d-flex justify-content-center mb-3">
                      <Captcha
                        captcha={captchaToken}
                        setUserCaptcha={setUserCaptcha}
                        userCaptcha={userCaptcha}
                        refreshCaptcha={handleCaptchaChange}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="form-group">
                    {isSubmitting ? (
                      <button
                        className="btn green-btn  w-100 cursor-na"
                        disabled
                      >
                        <Spinner size="sm" />
                      </button>
                    ) : (
                      <input
                        type="submit"
                        className="btn green-btn  w-100"
                        value="Get OTP"
                      />
                    )}
                  </div>
                </form>
              )}
              <div>
                Remember Password?{" "}
                <Link
                  to={URL_PATH.login}
                  className="green-text font-weight-bold"
                >
                  Login
                </Link>
              </div>
              <div>
                Don’t Have any Account?{" "}
                <Link
                  to={URL_PATH.membership}
                  className="green-text font-weight-bold"
                >
                  Sign Up
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CenterModal
        show={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        heading={message.heading}
        description={message.description}
        buttonText={"Try again"}
      />
    </section>
  );
};

export default ForgotPassword;
